import { typeList } from '@/views/producer/ics-authorization/authorization-option'
import { format } from 'date-fns'
import { IcsAdvertiserConfig } from '@/api/ics_advertiser/manage.type'

export const formValue: IcsAdvertiserConfig = {
  ssUid: undefined,
  accountType: 0,
  expireIn: format(new Date(), 'YYYY-MM-DD'),
  subAccountNum: 0,
  limitFlag: true,
  imgSum: 100,
  videoSum: 100,
}

const validateInit = (
  rule: any,
  value: any,
  callback: (e?: string) => void,
) => {
  const reg = /(^[1-9]\d*$)/
  if (reg.test(value) || value === 0) {
    callback()
  } else {
    // callback(new Error('error'))
    callback('请输入正整数')
  }
}

export const rules = {
  ssUid: [
    {
      required: true,
      message: '请选择授权客户名称',
      trigger: 'change',
    },
  ],
}

export const formItemList = [
  {
    component: 'autocomplete',
    prop: 'ssUid',
  },
  {
    component: 'select',
    label: '账号类型',
    prop: 'accountType',
    field: {
      placeholder: '请选择账号类型',
      options: typeList,
    },
    rules: [
      {
        required: true,
        message: '请选择账号类型',
        trigger: 'change',
      },
    ],
    description: '请选择授权客户名称',
  },
  {
    component: 'date-picker',
    label: '到期时间',
    prop: 'expireIn',
    rules: [{ required: true, message: '请选到期时间' }],
    field: {
      placeholder: '到期时间',
    },
  },
  {
    prop: 'subAccountNum',
    component: 'input',
    field: { type: 'number' },
    label: '子账号数量',
    rules: [
      {
        required: true,
        trigger: 'change',
        validator: validateInit,
      },
    ],
  },
  {
    component: 'radio-group',
    label: '是否限量',
    rules: [{ required: true }],
    prop: 'limitFlag',
    field: {
      options: [
        {
          value: true,
          label: '限量',
        },
        {
          value: false,
          label: '不限量',
        },
      ],
    },
  },
  {
    prop: 'imgSum',
    component: 'input',
    field: { type: 'number' },
    rules: [
      {
        required: true,
        trigger: 'change',
        validator: validateInit,
      },
    ],
    label: '图片',
    type: 'limitShow',
  },
  {
    prop: 'videoSum',
    component: 'input',
    field: { type: 'number' },
    rules: [
      {
        required: true,
        trigger: 'change',
        validator: validateInit,
      },
    ],
    label: '视频',
    type: 'limitShow',
  },
]
